module.exports = __webpack_public_path__ + "img/aa-1.cc70b3a6.png";